import Icon from "@ant-design/icons";

const LivingRoomFurnitureSvg = () => (
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="25"
    viewBox="0 0 512.000000 512.000000"
    preserveAspectRatio="xMidYMid meet"
  >
    <g
      transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
      fill="#31493C"
      stroke="none"
    >
      <path
        d="M1974 4873 c-12 -2 -30 -13 -40 -25 -18 -19 -19 -59 -22 -902 -1
-484 0 -896 3 -914 3 -18 15 -42 26 -53 19 -19 44 -19 1244 -19 1206 0 1225 0
1245 20 11 11 22 30 25 42 3 13 4 425 3 915 l-3 892 -23 23 c-22 22 -29 23
-251 26 -186 3 -235 1 -264 -12 -39 -16 -54 -47 -43 -92 11 -41 58 -54 198
-54 l122 0 -64 -65 -64 -65 -881 0 -881 0 -64 65 -64 65 748 2 748 3 24 28
c30 35 30 59 0 94 l-24 28 -839 1 c-461 1 -848 0 -859 -3z m163 -325 l63 -62
0 -566 0 -566 -70 -69 -70 -69 0 697 c0 383 3 697 7 697 4 0 36 -28 70 -62z
m2173 -635 l0 -697 -70 69 -70 69 0 565 0 565 62 63 c34 35 66 63 70 63 4 0 8
-314 8 -697z m-292 244 c1 -153 -1 -277 -6 -275 -4 1 -56 56 -116 121 -60 65
-122 125 -140 134 -44 24 -141 23 -190 -1 -26 -13 -109 -98 -249 -253 -201
-223 -212 -233 -227 -215 -67 86 -252 278 -282 293 -44 23 -124 25 -172 5 -21
-9 -82 -67 -157 -150 l-124 -137 -3 368 c-1 202 0 374 3 381 3 10 174 12 832
10 l828 -3 3 -278z m-319 -164 c11 -10 88 -92 170 -183 l150 -165 1 -122 0
-123 -344 0 -344 0 -61 69 -62 70 191 213 c106 117 203 223 216 236 30 27 55
28 83 5z m-760 -380 l192 -213 -391 0 -390 0 0 25 c0 17 48 77 172 215 150
167 175 191 199 188 20 -2 71 -52 218 -215z m1186 -433 l69 -70 -1009 0 -1009
0 69 70 69 70 871 0 871 0 69 -70z"
      />
      <path
        d="M3009 4327 c-24 -13 -57 -43 -74 -66 -27 -39 -30 -50 -30 -120 0 -69
3 -82 29 -119 36 -52 112 -92 175 -92 112 1 211 99 211 210 0 156 -173 259
-311 187z m145 -149 c21 -30 20 -54 -4 -78 -39 -39 -100 -14 -100 41 0 56 73
82 104 37z"
      />
      <path
        d="M299 4560 c-9 -5 -21 -22 -27 -37 -13 -31 -272 -1164 -272 -1186 0
-8 9 -26 21 -41 l20 -26 290 0 289 0 0 -1300 0 -1300 -33 0 c-192 0 -339 -114
-365 -284 -11 -69 -6 -99 20 -123 19 -17 51 -18 427 -21 223 -2 421 0 439 3
51 9 72 37 72 95 0 94 -56 202 -135 259 -58 42 -114 60 -202 68 l-73 6 2 1296
3 1296 95 0 95 0 3 -442 2 -442 26 -20 c15 -12 33 -21 40 -21 26 0 62 23 73
47 7 16 11 160 11 453 l0 430 114 0 c129 0 159 12 159 66 0 16 -59 290 -132
609 -118 518 -135 582 -157 603 l-25 22 -382 0 c-221 0 -389 -5 -398 -10z
m701 -146 c0 -3 50 -222 110 -486 61 -265 110 -487 110 -495 0 -11 -92 -13
-526 -13 -496 0 -525 1 -520 18 3 9 50 217 106 462 56 245 105 462 111 483
l10 37 299 0 c165 0 300 -3 300 -6z m-80 -3913 c31 -17 79 -60 91 -83 9 -17
-9 -18 -311 -18 l-321 0 15 28 c18 35 66 70 113 82 59 14 383 7 413 -9z"
      />
      <path
        d="M1893 2475 c-176 -48 -310 -192 -342 -369 -6 -33 -11 -125 -11 -206
l0 -146 -65 -28 c-85 -37 -148 -98 -188 -184 l-32 -67 -3 -587 -3 -586 25 -29
24 -28 1187 0 1187 0 24 28 c30 35 30 59 0 94 l-24 28 -846 3 -846 2 0 280 0
280 1205 0 1205 0 0 -280 0 -280 -220 0 c-244 0 -284 -7 -296 -54 -11 -44 4
-76 41 -92 28 -12 129 -14 579 -14 353 0 554 4 572 10 55 21 53 0 54 617 0
532 -1 575 -19 632 -34 109 -115 194 -227 237 l-44 17 -1 161 c0 186 -15 260
-69 350 -41 68 -115 138 -182 172 -109 55 -86 54 -1089 54 -510 0 -935 -3
-944 -6 -26 -10 -45 -63 -34 -93 21 -53 -24 -50 970 -51 1029 0 981 3 1074
-68 36 -27 60 -57 85 -106 l35 -69 3 -172 4 -172 -60 -22 c-78 -28 -149 -92
-193 -173 l-34 -63 -3 -193 -4 -192 -1201 2 -1202 3 -5 190 c-5 175 -7 194
-30 240 -38 78 -124 158 -199 185 l-63 23 4 172 3 172 35 69 c25 49 49 79 84
105 78 59 124 69 316 69 154 0 169 2 194 21 34 27 36 77 3 107 -22 21 -32 22
-203 21 -121 0 -196 -5 -231 -14z m-170 -897 c23 -13 55 -43 72 -66 l30 -44 3
-534 3 -534 -216 0 -215 0 0 508 c0 329 4 521 11 546 6 21 29 58 51 82 69 75
172 91 261 42z m3094 17 c61 -18 126 -83 142 -141 7 -25 11 -217 11 -546 l0
-508 -215 0 -215 0 0 522 c0 510 0 523 21 565 23 49 70 89 126 109 49 17 69
17 130 -1z"
      />
    </g>
  </svg>
);

const LivingRoomFurnitureIcon = (props) => (
  <Icon component={LivingRoomFurnitureSvg} {...props} />
);

export default LivingRoomFurnitureIcon;
